import {z} from "zod"
import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {AddressMode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/basic-definitions"
import {reduceOperator, shaderDefinition} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/hal/reduction-helper-hal"
import {imageOpHalOptions} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/hal/image-op-hal-types"

export const definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z.object({
            imageOpHalOptions: imageOpHalOptions,

            sourceImage: anyImageOpResult,
            operator: reduceOperator,
            custom: z
                .object({
                    reduce: shaderDefinition,
                    preProcess: shaderDefinition.optional(),
                    postProcess: shaderDefinition.optional(),
                })
                .optional(),
            options: z
                .object({
                    patchFillAddressMode: AddressMode.optional().default("border"),
                })
                .optional(),
        }),
    },
}
